export default __webpack_public_path__ + "static/media/project-diagram-solid.beca8a53.svg";